var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.through)?_c('el-link',{attrs:{"href":_vm.href,"underline":_vm.underline,"disabled":_vm.disabled,"target":_vm.target,"type":_vm.type,"icon":_vm.icon},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.text))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }